import apiInstance from '../../../utils/axios/apiInstance';


export const getCitiesService = (data: string) => {
  return apiInstance.get(`/get-cities/${data}`);
}

export const getCityService = (data: string) => {
  return apiInstance.get(`/city-by-slug/${data}`);
}

export const getCompaniesService = (data: string) => {
  return apiInstance.get(`/get-companies/${data}`);
}

export const getCompanyByUrlSlug = (slug: string) => {
  return apiInstance.get(`/company-by-slug?slug=${slug}`);
}


export const getPositionsService = (data: string) => {
  return apiInstance.get(`/get-positions?position=${data}`);
}


export const getPositionByUrlSlug = (slug: string) => {
  return apiInstance.get(`/position-by-slug?slug=${slug}`);
}

export const getPositionById = (id: string) => {
  return apiInstance.get(`/position-by-slug?id=${id}`);
}

